/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCookingCompetitionTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCookingCompetition,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Who’s the Best Chef?",
    "Culinary Showdown!",
    "Cooking Battle Awaits!",
  ],
  title: "Cooking Competition",
  description: "Organize a fun cooking competition.",
  longDescription:
    "Gather your friends for an exciting cooking challenge! Choose a date, select the dishes to prepare, and vote for the best chef!",
  emoji: "🍳",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Cooking Competition",
          emoji: "🍳",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the cooking competition?",
          emoji: "📅",
          completeAction: {
            question: "Decide on dishes to prepare?",
            description: "What dishes should we compete in making?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What dishes should we prepare?",
                emoji: "🍝",
                completeAction: {
                  question: "Decide on judging criteria?",
                  description:
                    "What criteria should we use to judge the dishes?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What criteria should we use?",
                      emoji: "🏆",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "May the Best Chef Win!",
    outroDescription:
      "Your cooking competition plans are set! Enjoy the culinary showdown!",
  },
};
